<template lang="pug">
  include ./../../../mixins
  div
    +b.g-row--justify_between.--align_center.g-cell
      +b.el--p_t_2xs-xl.--p_t_1xs
        +b.H1.ds-caption--c_white.--w_r-xl.--w_m.--size_8vw-xl.--size_4xl-md.--size_30xl.--h_130(
          id='topblock'
          class="ds-caption--upp"
        )
          | {{transText.title}}
      v-select(
        :options="listTitle",
        label="tag"
        :reduce="options => options.tag"
        v-model="formData.tag",
        :clearable="false"
        @input="sortCards()"
        class="vue-select"
        :searchable="false"
      )
    +b.el--p_t_xl-lg.--p_t_1sm(
      data-aos="fade-up"
      data-aos-once="false"
      data-aos-duration="700"
      data-aos-delay="400"
    )
      transition(:duration="700" name="nested")
        +b.g-row--space_10xl.inner(v-show="showTest")
          +b.g-cols--12.--6-md.--4-xl.--n_height.g-cell.el-cards-outlainer(
            v-for="(item, index) in cardsList"
            :key="index"
          )
            +b.cards-solutions
              +e.wrap
                +e.img
                  +b.IMG(:src='item.img')
                +b.el
                  +b.H2.ds-caption--c_white.--size_lg.--w_r.--h_130.--upp
                    | {{item.title}}
                +b.el--p_t_lg-lg.--p_t_sm
                  +b.P.ds-caption--c_white.--size_md-lg.--size_1xs.--w_l.--h_200.--op-4-lg(
                    v-html="item.text"
                  )
              +b.el--p_t_lg-lg.--p_t_1md
                +b.P.ds-caption--c_white.--size_md-lg.--size_11xs.--w_r.--h_130
                  | {{transText.cardsTitle}}
    div(
      v-if='recordsLength > perPage'
    )
      ui-limit-pagination(
        :current-page='Number(page)'
        :per-page='perPage'
        :total='recordsLength'
        @page="getPage($event), scrollToTop()"
      )
</template>

<script>
import qs from 'qs'

export default {
  data() {
    return {
      formData: {
        tag: '',
      },
      page: 1,
      perPage: 6,
      records: [],
      recordsLength: 0,
      showTest: true,
      cardListFull: [],
      listTitle: [],
      cardsList: [],
      catDef: '',
    }
  },
  props: {
    cards: {},
    transText: {},
  },
  mounted() {
    this.catDef = this.transText.catTitle
    this.formData.tag = this.catDef
    this.parseQueryString()
    this.cardsList = this.cards
    this.cardListFull = this.cards
    this.sortDublicateTag()
    this.listTitle.unshift({ tag: this.catDef })
    this.sortCardsMount();
    this.getRecordsLength();
    this.getPage(this.page);
  },
  methods: {
    getPage(data) {
      this.page = data
      this.showTest = false
      const cards = JSON.parse(JSON.stringify(this.cardListFull))
      setTimeout(() => {
        this.showTest = true
        const startIndex = this.perPage * (this.page - 1)
        this.cardsList = cards.splice(startIndex, this.perPage)
        this.updateUrl()
      }, 700);
    },
    scrollToTop() {
      const element = document.getElementById('topblock')
      if (element) {
        setTimeout(() => {
          const top = element.getBoundingClientRect().top + window.scrollY;
          window.scroll({
            // eslint-disable-next-line object-shorthand
            top: top,
            behavior: 'smooth',
          });
        }, 150);
      }
    },
    parseQueryString() {
      const url = decodeURIComponent(window.location.search)
      const parsed = qs.parse(url, { ignoreQueryPrefix: true, comma: true })
      if (parsed.page) {
        this.page = Number(parsed.page)
      }
      if (parsed.tag) {
        this.formData.tag = parsed.tag
      }
    },
    updateUrl() {
      const formData = {}
      if (this.page !== 1) {
        formData.page = this.page
      }
      if (this.formData.tag !== this.catDef) {
        formData.tag = this.formData.tag
      }
      const search = qs.stringify(formData, { addQueryPrefix: true })
      const fullUrl = window.location.pathname
      window.history.pushState({ url: fullUrl }, '', `${fullUrl}${search}`)
    },
    getRecordsLength() {
      const num = this.cardListFull.length
      this.recordsLength = num;
    },
    sortCards() {
      this.page = 1
      this.showTest = false
      setTimeout(() => {
        this.showTest = true
        this.sortCardsMount()
        this.updateUrl()
        const cards = JSON.parse(JSON.stringify(this.cardListFull))
        const startIndex = this.perPage * (this.page - 1)
        this.cardsList = cards.splice(startIndex, this.perPage)
        this.getRecordsLength()
      }, 700);
    },
    sortCardsMount() {
      if (this.formData.tag !== this.catDef) {
        this.cardsList = this.cards.filter(el => el.tag === this.formData.tag)
      } else {
        this.cardsList = this.cards
      }
      this.cardListFull = this.cardsList
    },
    sortDublicateTag() {
      this.listTitle = this.cards.reduce((el, index) => {
        if (!el.find(value => value.tag === index.tag)) {
          el.push(index);
        }
        return el;
      }, []);
    },
  },
}
</script>



// WEBPACK FOOTER //
// ./src/js/components/app/UiElements/FilterCards.vue